import $ from 'jquery'
import queryString from 'query-string'

export default {
  init() {
    console.log($('form.annuaire'))
    $('form.annuaire').on('submit', (e) => {
      e.preventDefault()
      const qs = {
        first_name: e.target.first_name.value,
        last_name: e.target.last_name.value,
        profession: e.target.profession.value
      };
      location.href = '/espace-adherent/annuaire?' + queryString.stringify(qs);
    })
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/espace-adherent-annuaire.js